import Route from '@ember/routing/route'
import { service } from '@ember/service'
import RSVP from 'rsvp'
import type { NormalizedInterval } from 'date-fns'
import type { SchoolScope, StudentsScope } from 'teacher-ui-client/reporting/ui-scope/utils'
import type ReportingUiScopeRoute from 'teacher-ui-client/reporting/ui-scope/route'
import type StudentEventsService from 'teacher-ui-client/services/student-events'

export class CourseProgressMathsLessonsRoute extends Route {
  @service studentEvents!: StudentEventsService

  async model() {
    const { uiScope, scopedData, period } = this.modelFor('reporting.ui-scope') as ModelFor<ReportingUiScopeRoute>

    const scopedStudents = scopedData.students
    const statsScope: StudentsScope = { scope: 'students', ids: scopedStudents.map((s) => s.id) }

    const product: LegacyProductMs = 'maths'
    const precinct: LegacyPrecinctLessons = 'lessons'
    const stats = await this.makeStatsRequests(product, precinct, statsScope, period)

    return {
      product,
      precinct,
      uiScope,
      scopedStudents: scopedData.students,
      ...stats,
    }
  }

  makeStatsRequests = async (
    product: LegacyProductMs,
    precinct: LegacyPrecinctLessons,
    scope: SchoolScope | StudentsScope,
    period: NormalizedInterval,
  ) => {
    const { studentEvents } = this
    return RSVP.hash({
      lessonsProgressTotals: studentEvents.courseProgressTotals(product, precinct, scope, period),
      lessonsProgressAverages: studentEvents.courseProgressAverages(product, precinct, scope, period),
      lessonsProgressHistory: studentEvents.courseProgressLessonHistory(product, precinct, scope, period),
    })
  }
}

export default CourseProgressMathsLessonsRoute
